var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3077 17.1114L36.5056 8.02099C36.71 7.81923 36.9703 7.68187 37.2537 7.62624C37.537 7.57061 37.8307 7.59921 38.0976 7.70843C38.3645 7.81765 38.5927 8.0026 38.7533 8.2399C38.9139 8.4772 38.9997 8.75623 39 9.04173V30.9588C38.9997 31.2443 38.9139 31.5233 38.7533 31.7606C38.5927 31.9979 38.3645 32.1828 38.0976 32.2921C37.8307 32.4013 37.537 32.4299 37.2537 32.3743C36.9703 32.3186 36.71 32.1813 36.5056 31.9795L27.3077 22.8891M5.38462 33.0002H22.9231C24.086 33.0002 25.2012 32.5437 26.0235 31.731C26.8457 30.9184 27.3077 29.8162 27.3077 28.6669V11.3336C27.3077 10.1843 26.8457 9.08211 26.0235 8.26945C25.2012 7.45679 24.086 7.00024 22.9231 7.00024H5.38462C4.22174 7.00024 3.1065 7.45679 2.28422 8.26945C1.46195 9.08211 1 10.1843 1 11.3336V28.6669C1 29.8162 1.46195 30.9184 2.28422 31.731C3.1065 32.5437 4.22174 33.0002 5.38462 33.0002Z",
    stroke: "#ECF6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera2);
export default __webpack_public_path__ + "static/media/video-camera2.871da1fccf70780b400255b1c8a03deb.svg";
export { ForwardRef as ReactComponent };